'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _antd = require('antd');

var _api = require('../../../../api');

var _GenericField = require('./GenericField');

var _GenericField2 = _interopRequireDefault(_GenericField);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VimeoVideo = function (_React$Component) {
	_inherits(VimeoVideo, _React$Component);

	function VimeoVideo(props) {
		_classCallCheck(this, VimeoVideo);

		var _this = _possibleConstructorReturn(this, (VimeoVideo.__proto__ || Object.getPrototypeOf(VimeoVideo)).call(this, props));

		_this.state = {
			isLoadingThumbnail: false,
			thumbnailError: ''
		};

		_this.getVimeoThumbnail = _this.getVimeoThumbnail.bind(_this);
		return _this;
	}

	_createClass(VimeoVideo, [{
		key: 'getVimeoThumbnail',
		value: function getVimeoThumbnail() {
			var _this2 = this;

			var _props = this.props,
			    onChangeFormField = _props.onChangeFormField,
			    index = _props.index,
			    form = _props.form;
			var value = form.value;


			var match = /external\/(\d+)\./.exec(value);

			if (match === null || match.length <= 1) {
				return;
			}

			this.setState({
				isLoadingThumbnail: true
			});

			var vimeoId = match[1];

			(0, _api.request)('get', '/vimeo/' + vimeoId + '/thumbnail').then(function (_ref) {
				var data = _ref.data;

				onChangeFormField('thumbnail', index, data.link_with_play_button);
				_this2.setState({ isLoadingThumbnail: false });
			}).catch(function (err) {
				_this2.setState({ isLoadingThumbnail: false, thumbnailError: err.message });
			});
		}
	}, {
		key: 'render',
		value: function render() {
			var _props2 = this.props,
			    form = _props2.form,
			    onChangeFormField = _props2.onChangeFormField,
			    index = _props2.index,
			    errorField = _props2.errorField;
			var thumbnail = form.thumbnail;

			return _react2.default.createElement(
				_GenericField2.default,
				this.props,
				_react2.default.createElement(
					_antd.Col,
					{ md: { span: 14 }, sm: 23 },
					_react2.default.createElement(
						_antd.Form.Item,
						{
							validateStatus: errorField === 'thumbnail' ? 'error' : 'success',
							help: errorField === 'thumbnail' ? 'Thumbnail inválido' : ''
						},
						_react2.default.createElement(
							_antd.Spin,
							{ spinning: this.state.isLoadingThumbnail },
							_react2.default.createElement(_antd.Input, {
								value: thumbnail,
								placeholder: 'Url do thumbnail',
								onChange: function onChange(e) {
									return onChangeFormField('thumbnail', index, e.target.value);
								}
							}),
							this.state.thumbnailError && _react2.default.createElement(
								'span',
								{ style: { color: 'red' } },
								this.state.thumbnailError
							)
						)
					)
				),
				_react2.default.createElement(
					_antd.Col,
					{ md: 3, sm: 10 },
					_react2.default.createElement(
						_antd.Button,
						{
							style: { marginLeft: 5 },
							loading: this.state.isLoadingThumbnail,
							onClick: this.getVimeoThumbnail
						},
						'Obter do Vimeo'
					)
				)
			);
		}
	}]);

	return VimeoVideo;
}(_react2.default.Component);

exports.default = VimeoVideo;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./src/client/components/genericMaterialAreas/ContentTree/formTypes/VimeoField.js
// module id = 3229
// module chunks = 0